import { useState } from 'react'
import { useNotifications, useView } from '@10000/react'
import { Body, Box, SelectButtons } from '../../widgets'
import { SubscriptionOption, SubscriptionSelect, PartnerPricingForm, PartnerPricing } from '../../subscription'
import { single, partner, subscriptions, isPartner } from '../../../lookups'
import { SettingsLayout } from '../'
import { ConfirmSubscription } from './'
import '../SettingsForm.scss'

export const Subscription = ({ goBackToSettingsMenu }) => {
  const { subscription, partnerRequest } = useView('tenant')
  const { notify } = useNotifications()

  const [selectedSubscription, setSelectedSubscription] = useState(subscription.index)
  const [confirmSubscription, setConfirmSubscription] = useState()

  const [showDetails, setShowDetails] = useState(false)
  const [showPartner, setShowPartner] = useState(false)

  const onNext = () => {
    if(isPartner({ index: selectedSubscription }) && !partnerRequest) {
      setShowPartner(true)
    } else if(selectedSubscription !== subscription.index && subscriptions[selectedSubscription]?.price) {
      setConfirmSubscription(true)
    } else {
      notify("You already have this subscription")
    }
  }

  const closeConfirmSubscription = () => {
    setConfirmSubscription(false)
    setSelectedSubscription(subscription.index)
  }

  return confirmSubscription
    ? <ConfirmSubscription selectedSubscription={selectedSubscription} onClose={closeConfirmSubscription}/>
    : <SettingsLayout
        buttonType={(!showPartner || (showPartner && partnerRequest)) && "next"}
        onClick={onNext}
        disabledButton={!subscriptions[selectedSubscription]?.price}
        gap={16}
        title="Subscription"
        backButtonMobileOnly
        onBackButtonClick={goBackToSettingsMenu}
      >
        <Box fullWidth>
          <Body bold align="left">Current subscription</Body>
        </Box>

        {subscriptions[subscription.index] && <SubscriptionOption
          width="100%"
          subscription={subscriptions[subscription.index]}
          onClick={() => setShowDetails(!showDetails)}
          background={'var(--blue)'}
          selected={showDetails}
          shadow={false}
        />}
        <Box fullWidth>
          <Body align="left">Select a new subscription</Body>
        </Box>

        <Box fullWidth>
          <SelectButtons
            fullWidth
            items={['All plans', 'Partners']}
            selectedIndex={showPartner ? 1 : 0}
            onClick={index => {
              setShowPartner(index === 1)
              if(index === 0){
                setSelectedSubscription(single[0].id)
              } else {
                setSelectedSubscription(partner[0].id)
              }
            }}
          />
        </Box>

      {showPartner
        ? partnerRequest
          ? <PartnerPricing onSubscriptionSelected={setSelectedSubscription} small dark/>
          : <PartnerPricingForm dark submitPlacedToBottom submitPadding="submit-full-padding"/>
        : <SubscriptionSelect
            dark
            onSubscriptionSelected={setSelectedSubscription}
            onPartnerChanged={setShowPartner}
          />
      }
    </SettingsLayout>
}